import { render, staticRenderFns } from "./TasteCombo.vue?vue&type=template&id=2f56e134&scoped=true&"
import script from "./TasteCombo.vue?vue&type=script&lang=js&"
export * from "./TasteCombo.vue?vue&type=script&lang=js&"
import style0 from "./TasteCombo.vue?vue&type=style&index=0&id=2f56e134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f56e134",
  null
  
)

export default component.exports